import React from "react";
const Star = ({ style }) => <span className={style}></span>;
export default Star;
